export default __webpack_public_path__ + "static/media/LeftArrowWhite.56f019d9.svg";